document.addEventListener('DOMContentLoaded', function () {
    const popupButton = document.querySelector('.nl-trigger-button');
    const popupClose = document.querySelectorAll('.nl-close');
    popupButton.addEventListener('click', function (e) {
        document.querySelector('.newsletter-overlay').style.display = 'block';
        document.querySelector('.newsletter-popup').style.display = 'block';
        document.querySelector('.newsletter-success').style.display = 'none';
    })
    popupClose.forEach((button) => {
        button.addEventListener('click', function (e) {
            const closeObj = document.querySelector('.' + button.dataset.close);
            closeObj.style.display = "none";
        })
    })

    let params = new URLSearchParams(document.location.search);
    let posted = params.get("customer_posted");
    if (params.has('customer_posted') && posted == "true" ) {
        document.querySelector('.newsletter-overlay').style.display = 'block';
        document.querySelector('.newsletter-popup').style.display = 'none';
        document.querySelector('.newsletter-success').style.display = 'block';
    }
})